import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

/**
 * BFF-backed free shipping threshold fetch.
 * Drop-in replacement for the direct shipping-go call in shipping.service.ts.
 */
export async function getFreeShippingThresholdViaBff(
  currencyCode: string,
): Promise<number | null> {
  const client = createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });

  try {
    const res = await client.getFreeShippingThreshold(currencyCode);
    return res.data.threshold;
  } catch {
    return null;
  }
}
